import Notifications from '../Notifications/notifications';

const initialState = {
   displayMobileSearch: false,
   displayMobileMenu: false,
   userTopics: null,
   notifications: new Notifications(),
   miniCart: {
      html: null,
      numProducts: 0,
   },
};

const headerReducer = (state = initialState, action) => {
   switch (action.type) {
      case 'TOGGLE_MOBILE_SEARCH':
         return {
            ...state,
            displayMobileSearch: action.value,
         };
      case 'UPDATE_WORKBENCH':
         return {
            ...state,
            userTopics: action.userTopics,
         };
      case 'UPDATE_NOTIFICATIONS':
         return {
            ...state,
            notifications: action.notifications,
         };
      case 'UPDATE_MINI_CART':
         return {
            ...state,
            miniCart: action.miniCartInfo,
         };
      case 'TOGGLE_MOBILE_MENU':
         return {
            ...state,
            displayMobileMenu: !state.displayMobileMenu,
         };
      default:
         return state;
   }
};

export default headerReducer;
